import { render, staticRenderFns } from "./showImg.vue?vue&type=template&id=0e1793d6&scoped=true&lang=html"
import script from "./showImg.vue?vue&type=script&lang=js"
export * from "./showImg.vue?vue&type=script&lang=js"
import style0 from "./showImg.vue?vue&type=style&index=0&id=0e1793d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e1793d6",
  null
  
)

export default component.exports